@let id = messageId();

<label mat-label class="sr-only" [for]="`message-edit-${id}`">
    {{ fieldLabel() }}
</label>
<mat-form-field qpxInput class="w-full alt-bg" subscriptSizing="dynamic">
    <textarea
        #editInput
        matInput
        [id]="`message-edit-${id}`"
        qpxTextareaAutosize
        minRows="3"
        maxRows="8"
        class="resize-y leading-normal"
        maxlength="500"
        [attr.aria-label]="fieldLabel()"
        [attr.aria-describedby]="
            !draft().trim() ? `message-edit-error-${id}` : null
        "
        [value]="draft()"
        (input)="onInput($event)"
        (keydown)="onKeyDown($event)"
    ></textarea>
    @if (!draft().trim()) {
        <mat-hint
            class="text-destructive-decorative"
            [id]="`message-edit-error-${id}`"
        >
            Enter a message before resending.
        </mat-hint>
    }
</mat-form-field>
<div class="flex justify-end gap-2">
    <button
        qpxButton
        [matButton]="appearance() === 'outlined' ? 'outlined' : 'filled'"
        context="card"
        size="sm"
        class="min-h-8"
        aria-label="Cancel message edit"
        (click)="editCancelled.emit()"
    >
        <ng-icon qpx matButtonIcon size="sm" name="lucideX" />
        <span>Cancel</span>
    </button>
    <button
        qpxButton
        [matButton]="appearance() === 'outlined' ? 'outlined' : 'filled'"
        size="sm"
        context="primary"
        class="min-h-8"
        [disabled]="!canResend()"
        aria-label="Resend edited message"
        (click)="resendRequested.emit()"
    >
        <ng-icon qpx matButtonIcon size="sm" name="lucideSend" />
        <span>Resend</span>
    </button>
</div>
